"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import { ApiProfileProxyAction } from "@/generated/models/ApiProfileProxyAction";
import { AuthContext } from "@/components/auth/Auth";
import { getTimeUntil } from "@/helpers/Helpers";
import PencilIcon, { PencilIconSize } from "@/components/utils/icons/PencilIcon";
export default function ProfileProxyEndTime(t0) {
  const $ = _c(18);
  const {
    profileProxy,
    profileProxyAction,
    onEndTimeEdit
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== connectedProfile || $[1] !== profileProxy) {
    t1 = () => {
      if (!connectedProfile) {
        return false;
      }
      return connectedProfile?.id === profileProxy.created_by.id;
    };
    $[0] = connectedProfile;
    $[1] = profileProxy;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getIsOwner = t1;
  const [isOwner, setIsOwner] = useState(getIsOwner());
  let t2;
  if ($[3] !== getIsOwner) {
    t2 = () => setIsOwner(getIsOwner());
    $[3] = getIsOwner;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== connectedProfile || $[6] !== profileProxy) {
    t3 = [connectedProfile, profileProxy];
    $[5] = connectedProfile;
    $[6] = profileProxy;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== profileProxyAction.end_time) {
    t4 = profileProxyAction.end_time ? getTimeUntil(profileProxyAction.end_time) : "Not set";
    $[8] = profileProxyAction.end_time;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = <span className="tw-whitespace-nowrap tw-text-iron-300 tw-text-md tw-font-normal">{t4}</span>;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== isOwner || $[13] !== onEndTimeEdit) {
    t6 = isOwner && <button type="button" aria-label="Edit end time" className="tw-group tw-bg-transparent tw-border-0 tw-h-8 tw-w-8 tw-flex tw-items-center tw-justify-center tw-rounded-full tw-text-iron-300 hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out" onClick={onEndTimeEdit}><PencilIcon size={PencilIconSize.SMALL} /></button>;
    $[12] = isOwner;
    $[13] = onEndTimeEdit;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <div className="tw-flex tw-items-center">{t5}{t6}</div>;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}